import { RESET_STATE, SET } from "@/stores/CommumActionTypes";
import {
	SET_SELECTED_TREND_SIGNAL_SETTINGS,
	SET_IS_TREND_SETTINGS_LOADING,
	SET_AVAILABLE_SIGNALS,
	CLEAR_AVAILABLE_SIGNALS,
	SET_COMMON_GROUP_EXPANDED,
	SET_DISTINCT_GROUP_EXPANDED,
	TOGGLE_COMMON_GROUP_EXPANDED,
	TOGGLE_DISTINCT_GROUP_EXPANDED,
	ON_TOGGLE_DISTINCT_ASSET_GROUP,
	SET_DISTINCT_ASSET_GROUP,
	SET_SHOW_SIGNAL_NAME_DIALOG,
	SET_MENU_OPENED,
	SET_NO_DATA_AVAILABLE,
	SET_FILTER_TEXT,
	SET_AVAILABLE_TREND_SIGNAL_SETTINGS,
	CLEAR_SELECTED_TREND_SIGNALS
} from "./TrendSignalSettingsActionsType";

const mutations = {
	[SET]: (state, trendSignals) =>
	{
		state.assetsTrendSettings = trendSignals;
	},

	[SET_SELECTED_TREND_SIGNAL_SETTINGS]: (state, assets) =>
	{
		state.selectedTrendSignalsSettings = assets || [];
	},

	[RESET_STATE]: (state) =>
	{
		state.selectedTrendSignalsSettings = [];
		state.availableCommonSignals = [];
		state.availableDistinctSignalGroups = [];
		state.expandedDistinctAssetGroups = [];
	},

	[SET_IS_TREND_SETTINGS_LOADING]: (state, isLoading) =>
	{
		state.isTrendSettingsLoading = isLoading;
	},

	[SET_AVAILABLE_SIGNALS]: (state, { commonSignals, distinctSignalGroups }) =>
	{
		state.availableCommonSignals = commonSignals || [];
		state.availableDistinctSignalGroups = distinctSignalGroups || [];
	},

	[CLEAR_AVAILABLE_SIGNALS]: (state) =>
	{
		state.availableCommonSignals = [];
		state.availableDistinctSignalGroups = [];
	},

	[SET_COMMON_GROUP_EXPANDED]: (state, value) =>
	{
		state.CommonGroupExpanded = value;
	},

	[SET_DISTINCT_GROUP_EXPANDED]: (state, value) =>
	{
		state.DistinctGroupExpanded = value;
	},

	[TOGGLE_COMMON_GROUP_EXPANDED]: (state) =>
	{
		state.CommonGroupExpanded = !state.CommonGroupExpanded;
	},

	[TOGGLE_DISTINCT_GROUP_EXPANDED]: (state) =>
	{
		state.DistinctGroupExpanded = !state.DistinctGroupExpanded;
	},

	[ON_TOGGLE_DISTINCT_ASSET_GROUP]: (state, assetName) =>
	{
		const index = state.expandedDistinctAssetGroups.indexOf(assetName);
		if (index > -1)
		{
			state.expandedDistinctAssetGroups.splice(index, 1);
		}
		else
		{
			state.expandedDistinctAssetGroups.push(assetName);
		}
	},

	[SET_DISTINCT_ASSET_GROUP]: (state, assetName) =>
	{
		state.expandedDistinctAssetGroups = assetName ? [ assetName ] : [];
	},
	[SET_SHOW_SIGNAL_NAME_DIALOG](state, value)
	{
		state.ShowSignalNameDialog = value;
	},
	[SET_MENU_OPENED]: (state, isOpen) =>
	{
		state.menuOpened = isOpen;
	},
	[SET_NO_DATA_AVAILABLE]: (state, value) =>
	{
		state.noDataAvailable = value;
	},
	[SET_AVAILABLE_TREND_SIGNAL_SETTINGS](state, assets)
	{
		state.assetsTrendSettings = assets;

		state.availableCommonSignals = assets[0]?.commonSignals || [];

		const groupedDistinctSignals = [];

		assets.forEach(assetSignals =>
		{
			if (!assetSignals.distinctSignals || assetSignals.distinctSignals.length === 0)
			{
				return;
			}

			const assetName = assetSignals.name;

			groupedDistinctSignals.push({
				assetName,
				signals: assetSignals.distinctSignals.map(signal => ({
					...signal,
					assetName,
				})),
			});
		});
		state.availableDistinctSignalGroups = groupedDistinctSignals;
		
		const allAssetNames = groupedDistinctSignals.map(group => group.assetName);
		state.expandedDistinctAssetGroups = allAssetNames;
	},
	[SET_FILTER_TEXT]: (state, text) =>
	{
		state.filterText = text;
	},
	[CLEAR_SELECTED_TREND_SIGNALS]: (state) =>
	{
		state.selectedTrendSignalsSettings = [];
	},
};

export default { mutations };
